import { OneSchemaImportProcessingMethod } from "generated-graphql/graphql";
import { Importer, ImporterProps } from "./Importer";

type WasteManifestImporterProps = Omit<ImporterProps, "processingMethod">;

export function WasteManifestImporter({
  templateType,
  refetchQueries = [],
  label,
  style,
  mode,
}: WasteManifestImporterProps) {
  return (
    <Importer
      templateType={templateType}
      refetchQueries={refetchQueries}
      label={label}
      style={style}
      processingMethod={OneSchemaImportProcessingMethod.Lambda}
      mode={mode}
    />
  );
}
